import { useCallback, useState } from "react";
import useSWR from "swr";

import {
  createSupplying,
  listSupplyings,
  SUPPLYINGS_KEY,
  type Supplying,
} from "@/features/product-stocks/api/supplyingApi";
import type { SupplyingData } from "@/features/product-stocks/types";
import { revalidate, toErrorMessage } from "@/lib/swr";

const EMPTY: Supplying[] = [];

export function useSupplyings() {
  const { data, error, isLoading, mutate } = useSWR(SUPPLYINGS_KEY, listSupplyings);

  return {
    supplyings: data ?? EMPTY,
    isLoading,
    error: toErrorMessage(error),
    refresh: mutate,
  };
}

export function useCreateSupplying() {
  const { mutate } = useSWR(SUPPLYINGS_KEY, listSupplyings);
  const [isCreating, setIsCreating] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const create = useCallback(
    async (payload: SupplyingData) => {
      setIsCreating(true);
      setError(null);
      try {
        const created = await createSupplying(payload);
        await Promise.all([mutate(), revalidate("product-stocks/", "provision-stocks/")]);
        return created;
      } catch (e) {
        setError(toErrorMessage(e));
        throw e;
      } finally {
        setIsCreating(false);
      }
    },
    [mutate],
  );

  return { create, isCreating, error };
}
